import { useForm, useFormState } from "react-final-form";
import SelectFileAssignmentInput from "../../../_src_shared/components/inputs/SelectFileAssignmentInput";
import InputWrapper from "../../inputs/shared/InputWrapper";
import Flx from "../../layout/Flx";
import RffFileDisplayName from "../inputs/RffFileDisplayName";

const RffDocumentMetaData = ({ sx, fileNameAsLoaded }) => {
  const {
    values: { docGroup, docType },
  } = useFormState();
  const { change } = useForm();

  const onDocGroupChange = (dg, dt) => {
    change("docGroup", dg);
    change("docType", dt); // Reset docType when docGroup changes
  };

  return (
    <Flx column fw gap={4} sx={sx}>
      <RffFileDisplayName
        name="file_display_name"
        suppressGrid
        label="File Display Name"
        fileNameAsLoaded={fileNameAsLoaded}
      />
      <InputWrapper fullWidth label={`Document Type`}>
        <SelectFileAssignmentInput
          placeholder="Search document categories and types..."
          onChange={(params) => {
            onDocGroupChange(params?.docGroup, params?.docType);
          }}
          onlyDisplayDocType
          docGroup={docGroup}
          docType={docType}
          sx={{ mb: 3 }}
        />
      </InputWrapper>
    </Flx>
  );
};

export default RffDocumentMetaData;
